module.exports = __webpack_public_path__ + "static/assets/2af318679f4d7294f83eee2d5f62cc88.svg";